import { render } from "./StrangeGame.vue?vue&type=template&id=d3f137d0"
import script from "./StrangeGame.vue?vue&type=script&lang=js"
export * from "./StrangeGame.vue?vue&type=script&lang=js"

import "./StrangeGame.vue?vue&type=style&index=0&id=d3f137d0&lang=css"

import exportComponent from "C:\\Users\\Mido\\Desktop\\Stuff\\Programming\\HTML_JS_PHP\\midorina.dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__